<template>
  <div>

    <a class="btn btn-primary btn-sm text-white d-block"
       @click="downloadFile()"><i
        class="fa fa-download"></i> {{ $t('text.globals.download') }}</a>

    <div class="col-md-12 metadataSidebar" ng-if="nodeData" :key="nodeData.id">
      <div class="mt-3 p-2 bg-light">
        <div class="row mb-3">
          <div class="col-md-12">
            <h5 class="mt-1">{{ $t('text.globals.documentInformation') }}</h5>
          </div>
        </div>
        <dl class="row" id="cm:title">
          <dt class="col-sm-3">{{ $t('text.metadata.title') }}</dt>
          <dd class="col-sm-9">{{
              nodeData.properties ? nodeData.properties["cm:title"] :
                  ''
            }}
          </dd>
        </dl>
        <dl class="row" id="id">
          <dt class="col-sm-3">{{ $t('text.metadata.id') }}</dt>
          <dd class="col-sm-9">{{ nodeData.id }}</dd>
        </dl>
        <dl class="row" id="rma:origionalName">
          <dt class="col-sm-3">{{ $t('text.metadata.originalName') }}</dt>
          <dd class="col-sm-9">{{
              (nodeData.properties && nodeData.properties["rma:origionalName"]) ?
                  nodeData.properties["rma:origionalName"] : '/'
            }}
          </dd>
        </dl>
        <dl class="row" id="cm:author">
          <dt class="col-sm-3">{{ $t('text.metadata.author') }}</dt>
          <dd class="col-sm-9">{{ nodeData.properties["cm:author"] }}</dd>
        </dl>
        <dl class="row" id="cm:description">
          <dt class="col-sm-12">{{ $t('text.metadata.description') }}</dt>
          <dd class="col-sm-12">{{ nodeData.properties["cm:description"] }}
          </dd>
        </dl>

        <div class="row">
          <div class="col-md-6" v-if="!deleted">
            <dl class="row" id="content.mimeTypeName">
              <dt class="col-md-12">{{ $t('text.metadata.mimeTypeName') }}</dt>
              <dd class="col-md-12">{{ nodeData.content.mimeTypeName ? nodeData.content.mimeTypeName : nodeData.content.mimeType }}</dd>
            </dl>
          </div>
          <div class="col-md-6" v-if="!deleted">
            <dl class="row" id="content.sizeInBytes">
              <dt class="col-md-12">{{ $t('text.metadata.sizeInBytes') }}</dt>
              <dd class="col-md-12">{{
                  nodeData.content.sizeInBytes |
                      prettyBytes
                }}
              </dd>
            </dl>
          </div>
        </div>
        <div class="row mb-0">
          <div class="col-md-12">
            <hr/>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <h5 class="mt-1 float-left"> {{ $t('text.globals.documentMetadata') }}</h5>

            <div class="btn btn-primary btn-sm text-white float-right"
                 @click="printDocument()"
                 v-if="$globalFunctions.checkForPermission('TISKANJE_META')">
              <i class="fa fa-print"></i> {{ $t('text.globals.print') }}
            </div>
            <div class="clearfix"></div>
          </div>
        </div>

        <div role="tablist" class="metadataList">


          <b-card no-body class="mb-1"
                  v-for="(item, index) in nodeData.types" :key="index"
                  v-if="item.name !== 'EH:verzioniranje' && item.name !== 'EH:pretvorjeno_gradivo_assoc_aspect'">
            <b-card-header header-tag="header" class="p-1" role="tab"
                           v-b-toggle="'accordion-bd' + index">
              {{ item.title }} <span
                v-if="item.title=='E-podpis'"> <small>({{ podpisi.length }})</small></span>

            </b-card-header>
            <b-collapse :id="'accordion-bd' + index" accordion="my-accordion"
                        role="tabpanel">
              <b-card-body v-if="item.title!='E-podpis'">
                <dl class="row" :id="innerItem.name"
                    v-for="(innerItem, innerIndex) in item.properties">
                  <dt class="col-sm-12">{{ innerItem.title }}:</dt>

                  <dd v-if="innerItem.name === 'EH:povezave_na_vodilne_dokumente'">
                    <ol class="pl-3" v-if="linksToParentDocument.length > 0">
                      <li v-for="item in linksToParentDocument"
                          :key="item.id"
                          style="font-size: 13px;">
                        <div class="btn btn-link text-left py-0 pl-1"
                             @click="goToDocument(item.id)"
                             style="font-size: 13px;">
                          <i v-if="item.content"
                             :class="$globalFunctions.getFileTypeIcon(item.content.mimeType)"></i>
                          <span>{{ item.properties ? item.properties['cm:title'] : '' }}</span>
                        </div>
                      </li>
                    </ol>
                    <em v-if="linksToParentDocument.length === 0">
                      <i class="fa fa-exclamation-triangle"></i>
                      {{ $t('text.documentDetailsMetadata.cannotGetMetadata') }}
                    </em>
                  </dd>

                  <dd v-if="innerItem.name === 'EH:komponenta_povezave_na_dokumente'">
                    <ol class="pl-3"
                        v-if="linksToParentDocumentComponents.length > 0">
                      <li v-for="item in linksToParentDocumentComponents"
                          :key="item.id"
                          style="font-size: 13px;">
                        <div class="btn btn-link text-left py-0 pl-1"
                             @click="goToDocument(item.id)"
                             style="font-size: 13px;">
                          <i v-if="item.content"
                             :class="$globalFunctions.getFileTypeIcon(item.content.mimeType)"></i>
                          <span>{{ item.properties ? item.properties['cm:title'] : '' }}</span>
                        </div>
                      </li>
                    </ol>
                    <em v-if="linksToParentDocumentComponents.length === 0">
                      <i class="fa fa-exclamation-triangle"></i>
                      {{ $t('text.documentDetailsMetadata.cannotGetMetadata') }}
                    </em>
                  </dd>


                  <dd class="col-sm-12" :data-name="innerItem.name"
                      v-if="innerItem.name !== 'EH:povezave_na_vodilne_dokumente' && innerItem.name !== 'EH:komponenta_povezave_na_dokumente'">
                                                                <span v-if="innerItem.dataType === 'd:date'">
                                                                    {{ nodeData.properties[innerItem.name] ? moment(nodeData.properties[innerItem.name]).utc().format("DD. MM. YYYY") : '/' }}
                                                                </span>
                    <span v-else-if="innerItem.dataType === 'd:datetime'">
                                                                    {{ nodeData.properties[innerItem.name] ? moment(nodeData.properties[innerItem.name]).utc().format("DD. MM. YYYY HH:mm:ss") : '/' }}
                                                                </span>
                    <span v-else-if="innerItem.dataType === 'd:boolean'">
                                                                    <span v-if="nodeData.properties[innerItem.name]"><i
                                                                        class="fa fa-check-circle"></i> {{ $t('text.globals.yes') }}</span>
                                                                    <span v-if="!nodeData.properties[innerItem.name]"><i
                                                                        class="fa fa-times-circle"></i> {{ $t('text.globals.no') }}</span>
                                                                </span>
                    <span v-else>
                                                                       {{ readableValue(innerItem.name, nodeData.properties[innerItem.name]) }}
                                                                </span>
                  </dd>
                </dl>

                <router-link
                    v-if="nodeData && item.name === 'EH:pretvorba_za_dolgorocno_hrambo' && longStorageDocumentIsAvailable"
                    class="btn btn-primary btn-sm text-white d-block"
                    :to="{name: 'DocumentInLongTermStorageDetails', params: {id: nodeData.id}}">
                  <i class="fa fa-eye"></i> {{ $t('text.documentDetailsMetadata.documentForLongTermStorage') }}
                </router-link>
                <router-link
                    v-if="nodeData && item.name === 'EH:pretvorba_za_dolgorocno_hrambo' && nodeData.properties['EH:format_gradiva_preverjen'] === true"
                    class="btn btn-success btn-sm text-white d-block mt-2"
                    :to="{name: 'UploadDocumentInLongTermStorageFormat', params: {id: nodeData.id}}">
                  <i class="fa fa-upload"></i>
                  {{ $t('text.documentDetailsMetadata.documentForLongTermStorageManualAdd') }}
                </router-link>
              </b-card-body>

              <b-card-body v-if="item.title=='E-podpis' && podpisi.length > 0">
                <div v-for="(podpis,idx) in podpisi" class="card mb-1">
                  <div class="card-body">

                    <small style="margin: 0 -10px 10px -10px;"
                           class="d-inline-block"><b>{{ $t('text.metadata.signature') }} #{{ idx + 1 }}</b></small>

                    <dl class="row" :id="innerItem.name"
                        v-for="(innerItem, innerIndex) in item.properties">
                      <dt class="col-sm-12">{{ innerItem.title }}:</dt>

                      <dd class="col-sm-12" :data-name="innerItem.name">
                                                                <span v-if="innerItem.dataType === 'd:date'">
                                                                    {{ podpis[innerItem.name] ? moment(podpis[innerItem.name]).utc().format("DD. MM. YYYY") : '/' }}
                                                                </span>
                        <span v-else-if="innerItem.dataType === 'd:datetime'">
                                                                    {{ podpis[innerItem.name] ? moment(podpis[innerItem.name]).utc().format("DD. MM. YYYY HH:mm:ss") : '/' }}
                                                                </span>
                        <span v-else-if="innerItem.dataType === 'd:boolean'">
                                                                    <span v-if="podpis[innerItem.name]"><i
                                                                        class="fa fa-check-circle"></i> {{ $t('text.globals.yes') }}</span>
                                                                    <span v-if="!podpis[innerItem.name]"><i
                                                                        class="fa fa-times-circle"></i> {{ $t('text.globals.no') }}</span>
                                                                </span>
                        <span v-else>
                                                                       {{ podpis[innerItem.name] ? podpis[innerItem.name] : '/' }}
                                                                </span>
                      </dd>
                    </dl>
                  </div>
                </div>

              </b-card-body>
            </b-collapse>
          </b-card>


          <b-card no-body class="mb-1"
                  :class="components.length === 0 ? 'opacity50' : ''">
            <b-card-header header-tag="header" class="p-1" role="tab"
                           v-b-toggle="'accordion-bd-komponente'">
              {{ $t('text.metadata.components') }}
              <small
                  v-if="components.length">({{ components.length }})</small>
            </b-card-header>
            <b-collapse :id="'accordion-bd-komponente'" accordion="my-accordion"
                        role="tabpanel" v-if="components.length">
              <b-card-body>
                <ol class="pl-1">
                  <li v-for="component in components"
                      :key="component.entry.id"
                      style="font-size: 13px;">
                    <div class="btn btn-link text-left py-0 pl-1"
                         @click="goToDocument(component.entry.id)"
                         style="font-size: 13px;">
                      <i v-if="component.entry.content"
                         :class="$globalFunctions.getFileTypeIcon(component.entry.content.mimeType)"></i>
                      <span>{{ component.entry ? component.entry.properties['cm:title'] : '' }}</span>
                    </div>
                  </li>
                </ol>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1"
                  :class="linksToLeadingDocument.length === 0 ? 'opacity50' : ''">
            <b-card-header header-tag="header" class="p-1" role="tab"
                           v-b-toggle="'accordion-bd-links'">
              {{ $t('text.metadata.attachments') }} <small
                v-if="linksToLeadingDocument.length">({{ linksToLeadingDocument.length }})</small>
            </b-card-header>
            <b-collapse :id="'accordion-bd-links'" accordion="my-accordion"
                        role="tabpanel" v-if="linksToLeadingDocument.length">
              <b-card-body>
                <ol class="pl-1">
                  <li v-for="linkToLeadingDocument in linksToLeadingDocument"
                      :key="linkToLeadingDocument.entry.id"
                      style="font-size: 13px;">
                    <div class="btn btn-link text-left py-0 pl-1"
                         @click="goToDocument(linkToLeadingDocument.entry.id)"
                         style="font-size: 13px;">
                      <i v-if="linkToLeadingDocument.entry.content"
                         :class="$globalFunctions.getFileTypeIcon(linkToLeadingDocument.entry.content.mimeType)"></i>
                      <span>{{ linkToLeadingDocument.entry ? linkToLeadingDocument.entry.properties['cm:title'] : '' }}</span>
                    </div>
                  </li>
                </ol>
              </b-card-body>
            </b-collapse>
          </b-card>

        </div>

        <router-link class="btn btn-sm btn-success text-white btn-block mt-3 mb-3"
                     :to="{name: 'AuditLog', params: {uuid: nodeData.id}}"><i
            class="fa fa-table"></i> {{ $t('text.documentDetailsMetadata.documentAuditLog') }}
        </router-link>

      </div>
    </div>

  </div>

</template>


<script>
import Vue from 'vue';
import {version} from '../../package';
import axios from "axios";

export default {
  name: 'DocumentDetailsMetadata',
  props: [
    "nodeOriginalData",
    "nodeData",
    "components",
    "linksToLeadingDocument",
    "linksToParentDocument",
    "linksToParentDocumentComponents",
    "deleted",
    "longStorageDocumentIsAvailable",
    "podpisi",
    "fileBlob"
  ],
  data() {
    return {
      allMetadataOptions: []
    };
  },
  async mounted() {
    this.allMetadataOptions = await this.$store.getters.getAllMetadataOptions;
  },
  methods: {
    goToDocument(id) {
      this.$router.push({name: 'DocumentDetails', params: {id: id}});
    },

    printDocument() {
      const _this = this;

      _this.isLoading = true;

      axios
          .get(config.reports + 'printDocumentDetails?nodeId=' + _this.nodeData.id, {
            responseType: "blob"
          })
          .then(res => {
            const url = window.URL.createObjectURL(
                _this.blobToFile(res.data, "Metapodatki")
            );
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", "Metapodatki dokumenta.pdf");
            link.setAttribute("type", "application/pdf");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            _this.isLoading = false;
          })
          .catch(error => {
            _this.isLoading = false;
            console.error(error);
          });


      // let save = document.createElement('a');
      // save.href = config.rootEhramba + 'printDocumentDetails?nodeId=' + _this.nodeData.id;
      // save.target = '_blank';
      // save.download = 'metapodatki.pdf';

      // let evt = new MouseEvent('click', {
      //     'view': window,
      //     'bubbles': true,
      //     'cancelable': false
      // });
      // save.dispatchEvent(evt);

      // (window.URL || window.webkitURL).revokeObjectURL(save.href);

      // setTimeout(function(){
      //     _this.isLoading = false;
      // }, 300);
    },

    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },

    downloadFile() {
      const _this = this;

      this.isLoading = true;

      const url = window.URL.createObjectURL(_this.blobToFile(_this.fileBlob, _this.nodeData.name));
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', _this.nodeData.name);
      link.setAttribute('type', _this.nodeData.content.mimeType);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.isLoading = false;
    }
  },
  readableValue(property, value) {
    const _this = this;
    if (_this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, property, value) && _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, property, value) !== 'undefined') {
      return _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, property, value)
    } else {
      return value ? value : '/'
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/DocumentDetailsMetadata.vue